import { timeValues } from "./config/time/timeValues";

export const locKeys = {
  time24hrs: timeValues.map((timeValue) => `wizard.time${timeValue}.text`),
  time12hrs: timeValues.map((timeValue) => `wizard.time${timeValue}12hr.text`),
};
